import {ampLog} from './amplitude';

export const trackEvent = (eventType: string, eventProperties?: object) => {
  ampLog(eventType, eventProperties);
};
